<template>
  <section class="section_bg container-fluid pt-2 pb-2   first_page" >
    <div class="d-flex justify-content-center"   >
      <div class="  ">
        <div class="second_section   block_row text-center pb-3 m-3">
          <div class="alert alert-danger">
            <p>Ваш аккаунт ожидает модерации. </p>
            <p>Только после одобрения администратора, вы сможете пользоваться сайтом</p>
            <p>Попробуйте обновить страницу позже.</p>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import UserModel from "../models/UserModel";

export default {
  name: "WaitingActivate",
  mounted(){
    var app=this;
    var user_data=UserModel.get();
    if(user_data && user_data.is_activate==1){
      app.$router.push({path:"/"});
    }
  },
}
</script>

<style scoped>

</style>